const Helpers = {
  methods: {
    translateFields (arr) {
      let fields = []
      arr.forEach(item => {
        const text = this.$t(item.text)
        fields.push({
          'text': text,
          value: item.value
        })
      })
      return fields
    }
  },
  computed: {
    tableRowClass () {
      return this.$vuetify.dark ? 'dark-table-row' : 'light-table-row'
    }
  }
}

export default Helpers



// WEBPACK FOOTER //
// ./src/mixins/Helpers.js